import { useEffect } from "react"
import { useHistory } from "react-router"
import { withRouter } from "react-router-dom"

function ScrollToTop() {
  const routerHistory = useHistory()
  useEffect(() => {
    const unlisten = routerHistory.listen(() => {
      window.scrollTo(0, 0)
    })
    return () => {
      unlisten()
    }
  }, [])

  return null
}

export default withRouter(ScrollToTop)
